import { render, staticRenderFns } from "./search_by_card.vue?vue&type=template&id=56b71fa6&scoped=true&"
import script from "./search_by_card.vue?vue&type=script&lang=js&"
export * from "./search_by_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b71fa6",
  null
  
)

export default component.exports